﻿import config from "../config"
const baseUrl = config.base_url + "z_farm_buy_shop_noauth/"
export default {
    list: {
        url:  baseUrl + "list",
        type: "get",
    },
    save: {
        url:  config.base_url + "z_farm_buy_shop/save",
        type: "post",
    },
}

